import React, { useEffect, useMemo, useState } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { MarketplaceDetailAside } from "../marketplace-detail-aside";

import ReactLoading from "react-loading";
import qs from "query-string";

export const MarketplaceDetailContent = (props) => {
  const { data, id } = props;
  const { t, i18n } = useTranslation();
  const [imgLoading, setImdloading] = useState(false);
  const [imgSrc, setImgSrc] = useState();
  const { consoleHost } =
    typeof window !== "undefined" && window._AUTHING__GLOBAL_CONFIG_;
  const protocol = useMemo(() => {
    return data?.supportedProtocols?.map((item) => item.protocol);
  }, [data]);
  const TYPEMAP = {
    "co-office": {
      "zh-CN": "协同办公",
      "en-US": "Team Collaboration",
    },
    "cloud-computing": {
      "zh-CN": "云计算资源",
      "en-US": "Team Collaboration",
    },
    marketing: {
      "zh-CN": "营销管理",
      "en-US": "Marketing Management",
    },
    devtools: {
      "zh-CN": "开发工具",
      "en-US": "Developer Tool",
    },
    hr: {
      "zh-CN": "人力资源",
      "en-US": "Developer Tool",
    },
    finance: {
      "zh-CN": "财税费控",
      "en-US": "Finance And Tax",
    },
    security: {
      "zh-CN": "零信任和安全",
      "en-US": "Security",
    },
    erp: {
      "zh-CN": "ERP",
      "en-US": "ERP",
    },
    other: {
      "zh-CN": "其他",
      "en-US": "Other",
    },
  };
  const toUperMap = {
    oidc: "OIDC",
    saml: "SAML",
    cas: "CAS",
    asa: "ASA",
  };
  const LodingRender = () => {
    return (
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "center",
          alignContent: "center",
          paddingTop: "40px",
        }}
      >
        <ReactLoading
          type="spinningBubbles"
          color="#396aff"
          height={60}
          width={60}
        />
      </div>
    );
  };
  useEffect(() => {
    const imgDom = new Image();
    setImdloading(true);
    imgDom.src = data?.readme
      .match(/### 预览\s*\!\[\]\(([\s\S]+)\)/)[1]
      .replace("{{cdnBase}}", "https://files.authing.co/authing-console");
    imgDom.onload = function () {
      setImdloading(false);
      setImgSrc(imgDom.src);
    };
  }, [data]);
  const detailMobileRender = () => {
    return (
      <div className="marketplace-detail-content-mobile">
        <div className="inner">
          <div className="go-back">
            <a href="/apn">
              <i
                className="icon authing-icon authing-arrow-down-line"
                style={{ transform: "rotate(-90deg)", display: "inline-block" }}
              ></i>
              <span className="text">
                {t("marketplace.detailApp.btn-goback")}
              </span>
            </a>
          </div>
          <div className="top-warp">
            <div className="icon-name-warp">
              <div className="icon">
                <img src={data?.logo} />
              </div>
              <div className="name-warp">
                <div className="title">
                  {data?.nameI18n[i18n.language] || data?.name}
                </div>
                <div className="subtitle">
                  {t("marketplace.detailApp.subtitle")}
                </div>
              </div>
            </div>
            {id === "esign" && (
              <div className="get-app-button-false">
                {t("marketplace.detailApp.forward")}
              </div>
            )}
            {id !== "esign" && (
              <div
                className="get-app-button"
                onClick={() => {
                  window.open(
                    `${consoleHost}/login?${qs.stringify({
                      state: `identifier.${id}`,
                    })}`
                  );
                }}
              >
                {t("marketplace.detailApp.btn-getapp")}
              </div>
            )}
          </div>
          <div className="app-overview">
            {imgLoading ? (
              LodingRender()
            ) : (
              <img
                src={id === "esign" ? data?.overviewImg : imgSrc}
                alt="authing"
              />
            )}
          </div>
          <div className="app-intro">
            <div className="title">
              {t("marketplace.detailApp.title-intro")}
            </div>
            <div className="descript">
              {data?.descriptionI18n[i18n.language]}
            </div>
          </div>
          <div className="app-info">
            <div className="title">{t("marketplace.detailApp.label-info")}</div>
            <div className="item">
              <div className="label">
                {t("marketplace.detailApp.label-category")}
              </div>
              <div className="text">
                {data?.categories?.map((item) => (
                  <div className="category">{TYPEMAP[item][i18n.language]}</div>
                ))}
              </div>
            </div>
            <div className="item">
              <div className="label">
                {t("marketplace.detailApp.label-developer")}
              </div>
              <div className="text">
                {t("marketplace.detailApp.label-developer-company")}
              </div>
            </div>
            <div className="item">
              <div className="label">
                {t("marketplace.detailApp.label-protocol")}
              </div>
              {protocol?.map((item) => (
                <div className="text">{toUperMap[item]}</div>
              ))}
            </div>
          </div>
          <div className="app-website">
            <div className="title">{t("marketplace.detailApp.title-link")}</div>
            <a
              href={data?.website}
              target="_blank"
              rel="noopener noreferrer"
              className="link"
            >
              {data?.website}
            </a>
          </div>
        </div>
      </div>
    );
  };

  const detailRender = () => {
    return (
      <div className="marketplace-detail-content">
        <div className="inner">
          <MarketplaceDetailAside
            icon={data?.logo}
            category={data?.categories}
            protocol={protocol}
          />
          <div className="marketplace-detail-warp">
            <div className="block-name">
              <div className="title">
                {data?.nameI18n[i18n.language] || data?.name}
              </div>
              {/* <div className="descript">
                {t("marketplace.detailApp.subtitle")}
              </div> */}
              <div className="descript">
                {data?.descriptionI18n[i18n.language]}
              </div>
            </div>

            {/* <div className="block block-intro">
              <div className="title">
                {t("marketplace.detailApp.title-intro")}
              </div>
              <div className="descript">
                {data?.descriptionI18n[i18n.language]}
              </div>
            </div> */}
            <div className="block block-link">
              <div className="title">
                {t("marketplace.detailApp.title-link")}
              </div>
              <a href={data?.website} target="_blank" rel="noopener noreferrer">
                {data?.website}
              </a>
            </div>
            <div className="block block-overview">
              <div className="title">
                {t("marketplace.detailApp.title-overview")}
              </div>

              <div className="img">
                {imgLoading ? (
                  LodingRender()
                ) : (
                  <img src={id === "esign" ? data?.overviewImg : imgSrc} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {detailRender()}
      {detailMobileRender()}
    </>
  );
};
